import { TEAM } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";
import { TeamPortrait } from "../TeamPortrait";

export const Team = () => (
  <section id="equipe" className="scroll-mt-20 bg-[#1D1327] py-24 lg:py-36" data-testid="section-equipe">
    <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
      <Reveal>
        <Eyebrow>L'équipe</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 max-w-3xl font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl">
          Cinq expertises complémentaires, une seule exigence.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-3 lg:grid-cols-5">
        {TEAM.map((member, i) => (
          <Reveal key={member.prenom} delay={i * 0.07}>
            <figure className="group" data-testid={`team-member-${member.id}`}>
              <div className="relative aspect-[3/4] overflow-hidden bg-card">
                <TeamPortrait member={member} />
              </div>
              <figcaption className="mt-4">
                <p className="font-serif text-2xl text-cream">{member.prenom}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-neon">{member.role}</p>
                <p className="mt-3 text-sm leading-relaxed text-white/50">{member.description}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
